import { formatDate } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PATH } from '@app/constants';
import { ProjectPreview, UserInfo } from '@interfaces/app';

import { DevelopmentService, ProjectsService, UserService } from '@app/services';
import { ModalService } from '@app/services/modal/modal.service';
import { PageTitleService } from '@app/services/page-title/page-title.service';
import { ToastrService } from 'ngx-toastr';
import { map } from 'rxjs';
import { DevelopmentPreview } from '@app/models';

@Component({
  selector: 'mnf-project-market',
  templateUrl: './project-market.component.html',
  styleUrls: ['./project-market.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectMarketComponent implements OnInit {

  user: UserInfo; 

  public readonly urlBaseS3 = 'https://static.monific.com/assets/projects-images/';
  private readonly JWT_TOKEN = 'JWT_TOKEN';
  private readonly REFRESH_TOKEN = 'REFRESH_TOKEN';
  private readonly ID_TOKEN = 'ID_TOKEN';
  private readonly EXP_AUTH = 'EXP_AUTH';

  selecteView: 'active' | 'funded' | 'liquidated';
  options = {
    'en-fondeo': 'active',
    'fondeados': 'funded',
    'liquidados': 'liquidated'
  };

  devs: DevelopmentPreview[];

  cardTitle: string;

  message: string = '';

  msgDynamic: string;
  titleDynamic: string;

  projects: ProjectPreview[];

  percentage: number = 0;

  showShareToast: boolean = false;
  isReferralInternal: boolean = false;
  codeReferralInternal: string = '';
  shareToastItems = [
    {
      class: 'whatsapp',
      icon: '/assets/icons/whatsapp.svg',
      alt: 'whatsapp',
      name: 'Whatsapp',
      url: '',
    },
    {
      class: 'copy-link',
      icon: '/assets/icons/paperclip.svg',
      alt: 'paperclip',
      onClick: () => this.copyLink(),
      name: 'Copiar enlace',
    }
  ];

  constructor(
   private readonly activatedRoute: ActivatedRoute,
   private readonly projectServ: ProjectsService,
   private readonly modalServ: ModalService,
   private readonly cdr: ChangeDetectorRef,
   private readonly toastServ: ToastrService,
   private readonly userServ: UserService,
   private readonly pageTitleService: PageTitleService,
   private readonly devServ: DevelopmentService
) { }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      this.selecteView = this.options[params.view];

      if (this.selecteView) {
        this.projectServ.getProjectsPreview(this.selecteView).subscribe(res => {

          this.projects = res;
          this.cdr.detectChanges();
        });

        switch(this.selecteView) {
          case 'active':
            this.titleDynamic = `Oportunidades para invertir`
            this.pageTitleService.setTitle('Inversionista | Proyectos activos');
            this.msgDynamic = `Descubre las oportunidades disponibles y comienza a invertir en bienes raíces de forma rápida y segura. Conoce cómo funciona cada tipo de proyecto:  <span style="color: #15394A; font-weight: bold;">Rendimiento fijo </span> y <span style="color: #8EB9CE; font-weight: bold;">Rendimiento variable.</span>`;
            this.getDevelopmentsActive();
            break;
          case 'funded':
            this.titleDynamic = `Proyectos fondeados`;
            this.pageTitleService.setTitle('Inversionista | Proyectos fondeados');
            this.msgDynamic = `Te presentamos los proyectos fondeados en su totalidad. Si te interesa participar consulta la disponibilidad en el mercado secundario.`;
            break;
          //case 'liquidated':
            //this.titleDynamic = `Proyectos liquidados`
            //this.msgDynamic = `Te presentamos los proyectos liquidados. <br>En estos proyectos ya se regresó el capital invertido y durante el periodo de inversión la gente recibió repartos de forma periódica.`;
            //break;
          default:
            this.titleDynamic = `Oportunidades para invertir`
            this.pageTitleService.setTitle('Inversionista | Proyectos activos');
            this.msgDynamic = `Descubre las oportunidades disponibles y comienza a invertir en bienes raíces de forma rápida y segura. Conoce cómo funciona cada tipo de proyecto: <span style="color: #15394A; font-weight: bold;">Rendimiento fijo </span> y <span style="color: #8EB9CE; font-weight: bold;">Rendimiento variable.</span>`;
            this.getDevelopmentsActive();
        }
        this.cdr.detectChanges();
        this.updateLinksInternalReferral();
      }
    });
  }

  viewVideo() {
    this.modalServ.openVideoModal('https://www.youtube.com/embed/_e1ifMJTwdY', true);
    this.cdr.detectChanges();
  }
  
  updateLinksInternalReferral() {
    if(sessionStorage.getItem(this.JWT_TOKEN) && sessionStorage.getItem(this.REFRESH_TOKEN) && sessionStorage.getItem(this.ID_TOKEN) && sessionStorage.getItem(this.EXP_AUTH)) {
      this.userServ.initInternalReferral().subscribe(res => {
        if(res?.id_referral) {
          this.isReferralInternal = true;
          this.codeReferralInternal = `https://app.monific.com/proyecto/mercado/en-fondeo?intrff=${res?.id_referral}`;
          this.shareToastItems[0].url = `https://wa.me/?text=${encodeURIComponent(this.codeReferralInternal)}`;
        }
      });
    }
  }  


  copyLink(): void {
    if (this.codeReferralInternal) {
      navigator.clipboard.writeText(this.codeReferralInternal).then(() => {
        this.toastServ.success('Enlace copiado al portapapeles');
      }).catch(err => {
        console.error('Error al copiar enlace:', err);
      });
    }
  }

  changeStateToastShare(){
    this.showShareToast = !this.showShareToast;
  }

  private getDevelopmentsActive() {
    this.devServ.getAllDevelopments()
      .pipe(
        map((items: any[]) => items.map((dev: any) => ({
          ...dev,
          priority: dev.priority || dev.d?.priority || 20
        }))),
        map((devs: any[]) => devs.sort((a: any, b: any) => a.priority - b.priority))
      )
      .subscribe((devs: any[]) => {
        this.devs = devs;
      });
  }

}
